import { render, staticRenderFns } from "./descriptabs.vue?vue&type=template&id=2a12392d&scoped=true&"
import script from "./descriptabs.vue?vue&type=script&lang=js&"
export * from "./descriptabs.vue?vue&type=script&lang=js&"
import style0 from "./descriptabs.vue?vue&type=style&index=0&id=2a12392d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a12392d",
  null
  
)

export default component.exports